import { useState } from 'react'
import { customerData } from '../../../utilities/CustomerData'
import { refreshAccessToken } from '../../../utilities/extensions'
import { apiURL } from '../../../utilities/URLs'
import { useNavigate } from 'react-router-dom'

export default function DashboardUploadReviewID({ setUploadReviewID, setManualIDReview }) {
  const navigate = useNavigate()
  const [frontId, setFrontId] = useState(null)
  const [backId, setBackId] = useState(null)
  const [spouseFrontId, setSpouseFrontId] = useState(null)
  const [spouseBackId, setSpouseBackId] = useState(null)
  const [submittingIds, setSubmittingIds] = useState(false)

  const handleUploadIDs = async () => {
    setSubmittingIds(true)
    const form = new FormData()
    form.append('front', frontId)
    form.append('back', backId)
    form.append('spousefront', spouseFrontId)
    form.append('spouseback', spouseBackId)

    const uploadIDsResponse = await fetch(`${apiURL}/api/uploadIDs?leadId=${encodeURIComponent(customerData.customerLeadData.leadId)}`, {
      method: 'POST',
      headers: {
        'Authorization': customerData.accessToken
      },
      body: form
    })
    const uploadIDsData = await uploadIDsResponse.json()
    setSubmittingIds(false)

    if(uploadIDsData.response.error) {
      if(uploadIDsData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? handleUploadIDs() : navigate('/team', { state: { expired: true } })
      } else
        console.error(uploadIDsData.response.error)
    } else {
      setFrontId(null)
      setBackId(null)
      setSpouseFrontId(null)
      setSpouseBackId(null)
      setUploadReviewID(false)
      setManualIDReview(true)
    }
  }

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-[#646464]'>We have detected that your IDs are expired. Please upload clear front and back images of your non-expired ID.</p>
        <div className='flex flex-col gap-3 w-full'>
          <label className='text-sm font-semibold text-[#646464]'>
            Upload Front of ID (JPG only)
            <input
              type='file'
              accept='.jpg'
              onChange={(e) => setFrontId(e.target.files[0])}
              className='mt-1 w-full border border-gray-300 rounded-md p-2'
            />
          </label>

          <label className='text-sm font-semibold text-[#646464]'>
            Upload Back of ID (JPG only)
            <input
              type='file'
              accept='.jpg'
              onChange={(e) => setBackId(e.target.files[0])}
              className='mt-1 w-full border border-gray-300 rounded-md p-2'
            />
          </label>
          {customerData.customerMultipleSourceIncome.didSpouseCalculation && (
            <div>
              <label className='text-sm font-semibold text-[#646464]'>
                Upload Spouse Front of ID (JPG only)
                <input
                  type='file'
                  accept='.jpg'
                  onChange={(e) => setSpouseFrontId(e.target.files[0])}
                  className='mt-1 w-full border border-gray-300 rounded-md p-2'
                />
              </label>

              <label className='text-sm font-semibold text-[#646464]'>
                Upload Spouse Back of ID (JPG only)
                <input
                  type='file'
                  accept='.jpg'
                  onChange={(e) => setSpouseBackId(e.target.files[0])}
                  className='mt-1 w-full border border-gray-300 rounded-md p-2'
                />
              </label>
            </div>
          )}
        </div>
        <button onClick={handleUploadIDs} disabled={!frontId || !backId || (customerData.customerMultipleSourceIncome.didSpouseCalculation && (!spouseFrontId || !spouseBackId)) || submittingIds} className={`mt-4 px-4 py-2 rounded-md text-white font-semibold transition-all ${frontId && backId &&  (customerData.customerMultipleSourceIncome.didSpouseCalculation ? (spouseFrontId && spouseBackId) : true) && !submittingIds ? 'bg-primaryColor hover:bg-primaryDarkColor' : 'bg-gray-400 cursor-not-allowed'}`}>
          Submit
        </button>
        <p className='text-sm text-[#646464] mt-2 italic'>Note: We securely store your ID only during the review process. Once your ID is verified and accepted, it is permanently deleted from our system.</p>
        {submittingIds && (
          <div className='flex flex-row items-center justify-center gap-2 mt-5 w-full col-span-2'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8'></div>
            <p className='text-md text-center'>Submitting ID's...</p>
          </div>
        )}
      </div>
    </div>
  )
}
